module.exports = __webpack_public_path__ + "img/nf_caseinfo.ce86169e.png";